<template>
   <Path>
        <template v-slot:path>
            <li><router-link :to="{name: 'dashboard'}" >الصفحة الرئيسية</router-link> </li>
            <li> <span class="divider"> / </span><a href="#services" @click="$router.push({name: 'dashboard'})">الخدمات </a> </li> 
            <li> <span class="divider"> / </span> <router-link :to="{name:'translatedservices'}" >الخدمات المترجمة</router-link></li>      
        </template>
   </Path>

  <section id="content">
        <div class="py-6 ">
            <div class="container services_inner">

                <div id="carouselServicesInner" class="carousel slide" data-bs-ride="true">
                    <div class="carousel-inner">
                      <div class="carousel-item active">
                        <div class="row row-cols-2 row-cols-lg-3 g-4">
    
                            <div class="col pointer ">
                                <div @click="ToBirthRegulations" class="scal_box rounded ">
                                    <div class="icon_holder  mt-3">
                                        <!-- <button @click="ToBirthDoc" type="button" class="pa-0  ma-0  icon-btn"><i class="bi bi-file-earmark-text"></i></button> -->
                                        <i class="bi bi-file-earmark-text"></i>
                                    </div>
                                    <p>شهادة ميلاد </p>
                                </div>
                            </div>
        
                            <div class="col pointer ">
                                <div @click="ToDeathRegulations" class="scal_box rounded ">
                                    <div class="icon_holder  mt-3">
                                        <i class="bi bi-file-earmark-text"></i>
                                    </div>
                                    <p>قيد وفاة</p>
                                </div>
                            </div>
                            <div class="col pointer ">
                                <div @click="ToMarriageRegulations"  class="scal_box rounded ">
                                    <div class="icon_holder  mt-3">
                                       <i class="bi bi-file-earmark-text"></i>
                                    </div>
                                    <p>قسيمة زواج</p>
                                </div>
                            </div>
        
                            <div class="col pointer ">
                                <div  @click="ToDivorceRegulations" class="scal_box rounded ">
                                    <div class="icon_holder  mt-3">
                                       <i class="bi bi-file-earmark-text"></i>
                                    </div>
                                    <p>قسيمة طلاق</p>
                                </div>
                            </div>
        
                            <div class="col pointer ">
                                <div @click="ToFamilyRecRegulations" class="scal_box rounded ">
                                    <div class="icon_holder  mt-3">
                                        <i class="bi bi-file-earmark-text"></i>
                                    </div>
                                    <p>قيد عائلي</p>
                                </div>
                            </div>
        
                            <div class="col pointer ">
                                <div @click="ToPersonalRecRegulations" class="scal_box rounded ">
                                    <div class="icon_holder  mt-3">
                                        <i class="bi bi-file-earmark-text"></i>
                                    </div>
                                    <p>قيد فردي </p>
                                </div>
                            </div>
                        </div>
                      </div>
                    </div>
                  </div>
            </div>
        </div>
  </section>
  <router-view></router-view>
</template>

<script>
import Path from '@/components/Path.vue';

export default {
  name: 'TranslatedServicesView',
  components:{
    Path
  },
  created(){
    window.scrollTo({ top: 0, behavior: "smooth" });
  },
  methods:{
    ToBirthRegulations(){
        this.$router.push({name:'translateddocsreg', params: {docType : 'birth'}});
    },
    ToDeathRegulations(){
        this.$router.push({name:'translateddocsreg', params: {docType : 'death'}});
    },
    ToMarriageRegulations(){
        this.$router.push({name:'translateddocsreg', params: {docType : 'marriage'}});
    },
    ToDivorceRegulations(){
        this.$router.push({name:'translateddocsreg', params: {docType : 'divorce'}});
    },
    ToPersonalRecRegulations(){
        this.$router.push({name:'translateddocsreg', params: {docType : 'personalrecord'}});
    },
    ToFamilyRecRegulations(){
        this.$router.push({name:'translateddocsreg', params: {docType : 'familyrecord'}});
    },
  }
}
</script>
